/**
 * @prettier
 */

import { useTranslation } from "react-i18next";
import { imageAlt } from "../../../config/accessabilityRules";
import CustomButton from "../../../components/CustomButton";
import { ACTION_LABELS } from "../../../config/dataDogActionLabels";
import { useRotatableImageContainer } from "./useRotatableImageContainer";

const ACTION = ACTION_LABELS.processResults;

const FailedVerification = ({
    isExpired,
    pageFocusRef,
    cardImage,
    retryDocumentUpload,
}) => {
    const { t } = useTranslation();
    const { ImageContainer } = useRotatableImageContainer();
    return (
        <>
            <h1
                className={"error-message-text"}
                ref={pageFocusRef}
                tabIndex={0}
            >
                {isExpired
                    ? t("idpal_id_verification_expired")
                    : t("idpal_id_verification_failed")}
            </h1>
            <ImageContainer
                cardImage={cardImage}
                imageAltText={imageAlt.upLoadedDocument}
                src={cardImage}
            />
            <div className="document-review-cta-container">
                <CustomButton
                    id={"retry"}
                    type="customHover"
                    label={t("idpal_retry")}
                    handleClick={() => retryDocumentUpload()}
                    actionDataLabel={ACTION.retryUploadButton}
                />
            </div>
        </>
    );
};

export default FailedVerification;
